import { Injectable, inject } from '@angular/core';
import { ContactUsForm } from '@app/core/models/contact-us-form';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { CountryWithPlatforms } from '@app/core/services/countries/countries.types';

@Injectable({
  providedIn: 'root',
})
export class ContactSupportService {
  private httpClient = inject(HttpClient);

  private readonly endpoint = environment.contactUsApiUrl;
  private readonly supportCountriesUrl = `${this.endpoint}/countries`;

  sendContactUsForm(contactUsForm: ContactUsForm): Observable<void> {
    return this.httpClient.post<void>(`${this.endpoint}`, contactUsForm);
  }

  getSupportCountries(): Observable<CountryWithPlatforms[]> {
    return this.httpClient.get<CountryWithPlatforms[]>(
      this.supportCountriesUrl,
    );
  }
}
